import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '@app/environment';
import { provideTranslateCompiler, provideTranslateService } from '@ngx-translate/core';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { provideStore } from '@ngxs/store';
import { provideEchartsCore } from 'ngx-echarts';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

import packageJson from '../../package.json';
import { APP_ROUTES } from './app.routes';
import { provideCasl } from './casl.provider';
import { provideAuth } from './core/auth/auth.provider';
import { HTTP_INTERCEPTORS } from './core/http-interceptors';
import { provideLocales, registerCoreLocales } from './core/locales';
import { provideMediaBreakpoints } from './core/media-observer/media-breakpoints.provider';
import { provideSidenav } from './core/sidenav';
import { provideSvgIcons, SVG_ICONS } from './core/svg-icon';
import { provideAppVersion } from './core/tokens';
import { provideUpdater } from './core/updater';
import { provideGraphQl } from './graphql.provider';

const MAT_FORM_FIELD_OPTIONS: MatFormFieldDefaultOptions = {
  appearance: 'outline',
};

registerCoreLocales();

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptors(HTTP_INTERCEPTORS)),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(APP_ROUTES),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: MAT_FORM_FIELD_OPTIONS,
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !environment.isLocal,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideStore(
      [],
      {
        developmentMode: !environment.production,
      },
      withNgxsStoragePlugin({
        keys: ['auth.tokens', 'preferences', 'locales'],
      }),
    ),
    provideEchartsCore({
      echarts: () => import('echarts'),
    }),
    provideDateFnsAdapter(),
    provideCasl(),
    provideGraphQl(),
    provideAppVersion(packageJson.version),
    provideAuth(),
    provideMediaBreakpoints({
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1400,
      xxxl: 1600,
    }),
    provideSvgIcons(SVG_ICONS),
    provideUpdater(),
    provideSidenav(),
    provideAnimations(),
    provideLocales(),
    provideTranslateService({
      compiler: provideTranslateCompiler(TranslateMessageFormatCompiler),
    }),
  ],
};
